import { Component, inject } from '@angular/core'
import { Icon } from '@app/components/icon/icon'
import { ToastService } from '@core/services/common'
import { ToastMessage } from '@/app/types/toast'
import { NgbToast } from '@ng-bootstrap/ng-bootstrap'

@Component({
  selector: 'app-toast-container',
  imports: [NgbToast, Icon],
  templateUrl: './toast-container.html',
  styles: `
    .app-toast-container {
      z-index: 1090;
    }

    .app-toast {
      min-width: 220px;
      max-width: 360px;
    }

    /* Soft notification / semantic toasts (TADA-like) */
    .app-toast--soft {
      border: 1px solid transparent;
      border-inline-start-width: 4px;
      box-shadow: 0 8px 24px rgba(15, 23, 42, 0.12);
    }

    .app-toast--soft.app-toast--success {
      background-color: #f3faf6;
      border-color: rgba(34, 160, 107, 0.28);
      border-inline-start-color: #22a06b;
      color: #006644;
    }

    .app-toast--soft.app-toast--info {
      background-color: #f5f8ff;
      border-color: rgba(0, 82, 204, 0.22);
      border-inline-start-color: #0052cc;
      color: #0052cc;
    }

    .app-toast--soft.app-toast--warning {
      background-color: #fffbf0;
      border-color: rgba(226, 162, 3, 0.35);
      border-inline-start-color: #e2a203;
      color: #974f0c;
    }

    .app-toast--soft.app-toast--error {
      background-color: #fff6f5;
      border-color: rgba(227, 73, 53, 0.28);
      border-inline-start-color: #e34935;
      color: #ae2a19;
    }

    .app-toast--soft .fw-semibold {
      color: #1e1d60;
    }

    .app-toast--soft.app-toast--success .fw-semibold {
      color: #006644;
    }

    .app-toast--soft.app-toast--info .fw-semibold {
      color: #0052cc;
    }

    .app-toast--soft.app-toast--warning .fw-semibold {
      color: #974f0c;
    }

    .app-toast--soft.app-toast--error .fw-semibold {
      color: #ae2a19;
    }
  `,
})
export class ToastContainer {
  readonly toastService = inject(ToastService)

  toastClass(toast: ToastMessage): string {
    const appearance = toast.appearance ?? 'solid'
    if (appearance === 'solid' && toast.type === 'success') {
      return 'text-bg-success border-0 app-toast'
    }
    return `app-toast app-toast--soft app-toast--${toast.type}`
  }

  toastIcon(toast: ToastMessage): string {
    if (toast.icon) return toast.icon
    switch (toast.type) {
      case 'info':
        return 'info'
      case 'warning':
        return 'triangle-alert'
      case 'error':
        return 'circle-x'
      case 'success':
      default:
        return 'check'
    }
  }
}
